/**
 * Created by Doma on 2016/10/19.
 */
import Vue from 'vue'
export default new Vue()



/** WEBPACK FOOTER **
 ** ./src/helpers/EventBus.js
 **/